module.exports = __webpack_public_path__ + "images/旅悦好物全景_04-3.jpg?v=87ffb8f4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_04-3.jpg
 ** module id = 134
 ** module chunks = 1 2
 **/